module.exports = __webpack_public_path__ + "img/shoulder-endo-mesomorph-male.6d3909c3.svg";